import { SVGIcon } from '../Icons'
import { ISVGProps } from '../types'

const List = (props: ISVGProps) => (
  <SVGIcon {...props}>
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1310_18584)">
        <path
          d="M3 10.8333H4.66667V9.16667H3V10.8333ZM3 14.1667H4.66667V12.5H3V14.1667ZM3 7.5H4.66667V5.83333H3V7.5ZM6.33333 10.8333H18V9.16667H6.33333V10.8333ZM6.33333 14.1667H18V12.5H6.33333V14.1667ZM6.33333 5.83333V7.5H18V5.83333H6.33333ZM3 10.8333H4.66667V9.16667H3V10.8333ZM3 14.1667H4.66667V12.5H3V14.1667ZM3 7.5H4.66667V5.83333H3V7.5ZM6.33333 10.8333H18V9.16667H6.33333V10.8333ZM6.33333 14.1667H18V12.5H6.33333V14.1667ZM6.33333 5.83333V7.5H18V5.83333H6.33333Z"
          fill="#555555"
        />
      </g>
      <defs>
        <clipPath id="clip0_1310_18584">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  </SVGIcon>
)

export default List
